import { useTitle } from "@hireroo/app-helper/react-use";
import { SupportLanguageValue, useLanguageCode, useTranslation } from "@hireroo/i18n";
import { Widget } from "@hireroo/presentation";

type GenerateMaintenanceProps = {};

export const useGenerateProps = (_args: GenerateMaintenanceProps): Widget.ErrorPanelProps => {
  const { t } = useTranslation();
  const lang = useLanguageCode();
  const helpPageUrlMap: Record<SupportLanguageValue, string> = {
    ja: import.meta.env.VITE_MAINTENANCE_DETAIL_URL_JA,
    en: import.meta.env.VITE_MAINTENANCE_DETAIL_URL_EN,
  };

  useTitle(t("メンテナンス中"));

  return {
    name: t("ただいまシステムのメンテナンス中です。"),
    message: t("メンテナンスに関する情報はヘルプページをご確認ください。"),
    links: [
      {
        href: helpPageUrlMap[lang],
        children: t("ヘルプページ"),
      },
    ],
  };
};
